export interface User {
  email: string;
  is_active: boolean;
  is_superuser: boolean;
  is_teacher: boolean;
  is_parent: boolean;
  is_first_connection: boolean;
  is_survey_finished: boolean;
  school_name: string;
  limit_date: string;
  pseudo?: string;
  centers_of_interest?: string[];
  age: number;
  graphism?: string;
  gender?: string;
  avatar_id?: string;
  created_at: string;
  id: string;
  nb_days_left: number | null;
  tier: UserTier;
  first_name: string | null;
  last_name: string | null;
  gar_ido: string | null;
}

export enum UserTier {
  free = 'free',
  premium = 'premium',
}
